<!--
 * @Description: 自建课程
 * @Author: xiawenlong
 * @Date: 2021-04-25 17:36:53
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-08-23 16:47:54
-->
<template>
  <div class="course-by-self">
    <table-list
      class="tableList"
      title="课程列表"
      :loading="loading"
      :data="courseList"
      :search-form="searchForm(this)"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      :btns="btns(this)"
      :options="{ selection: true, operatesWidth: 120, fixScrollTable: true }"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 顶部按钮
const btns = _this => [
  {
    label: '创建课程',
    method: _this.handleAdd,
  },
  {
    label: '复制副本',
    method: _this.handleCopy,
  },
  {
    label: '删除',
    method: _this.handleDelete,
    type: 'danger',
  },
]
// 搜索框配置
const searchForm = () => [
  {
    label: '课程名称',
    prop: 'keyword',
  },
  {
    label: '课程类型',
    type: 'select',
    prop: 'courseType',
    children: [
      { value: 0, label: '录播' },
      { value: 1, label: '直播' },
    ],
  },
  {
    label: '课程状态',
    type: 'select',
    prop: 'enable',
    children: [
      { value: 0, label: '禁用' },
      { value: 1, label: '启用' },
    ],
  },
  {
    label: '上传时间',
    type: 'picker',
    prop: 'createTime',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'courseId',
    label: '课程编号',
    minWidth: 80,
  },
  {
    prop: 'mobile',
    label: '课程封面',
    render: (h, { row }) => {
      return [
        row.pic
          ? h('img', {
              domProps: { src: row.pic },
              style: 'height: 50px',
            })
          : null,
      ]
    },
  },
  {
    prop: 'courseName',
    label: '课程名称',
    minWidth: 150,
  },
  {
    prop: 'courseType',
    label: '课程类型',
    formatter: row => {
      return { 0: '录播', 1: '直播', 9: '未知' }[row.courseType]
    },
  },
  {
    prop: 'teacherName',
    label: '任课老师',
  },
  {
    prop: 'credit',
    label: '学分',
    align: 'right',
  },
  {
    prop: 'academicHour',
    label: '课时',
    align: 'right',
  },
  {
    prop: 'chapterCount',
    label: '章节数',
    sortable: 'sortable',
    align: 'right',
    minWidth: 100,
  },
  {
    prop: 'durationCount',
    label: '课程时长（分钟）',
    formatter: row => {
      return row.durationCount
    },
    sortable: 'sortable',
    align: 'right',
    minWidth: 170,
  },
  {
    prop: 'createTime',
    label: '创建时间',
    sortable: 'sortable',
    minWidth: 150,
  },
  {
    prop: 'enable',
    label: '可用状态',
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.enable },
          on: {
            change: async v => {
              await _this.handleStatusChange(row.courseId, v, row)
            },
          },
        }),
      ]
    },
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    label: '编辑',
    method: _this.handleEdit,
  },
  {
    label: '章节管理',
    method: _this.handleSection,
  },
]
import TableList from '@/components/TableList'
import { courseList, courseStatus, courseDel, courseCopy } from '@/api/course'
import to from 'await-to'
export default {
  name: 'CourseBySelf',
  components: {
    TableList,
  },
  data() {
    return {
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      courseList: [],
      selectCourse: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      queryParams: {},
    }
  },
  mounted() {
    this.getCourse()
  },
  methods: {
    async getCourse() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(courseList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.courseList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.createTime) {
        queryParams.startTime = queryParams.createTime[0]
        queryParams.endTime = queryParams.createTime[1]
      } else {
        queryParams.startTime = ''
        queryParams.endTime = ''
      }
      this.queryParams = queryParams
      this.getCourse()
    },
    handleAdd() {
      this.$router.push('/course/library/add')
    },
    async handleCopy() {
      if (!this.selectCourse.length) return this.$message.warning('请先选择要复制的课程')
      let courseIds = []
      this.selectCourse.map(item => courseIds.push(item.courseId))
      const [, err] = await to(courseCopy({ courseId: courseIds }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('复制成功')
      this.getCourse()
    },
    // 编辑
    handleEdit({ courseId }) {
      this.$router.push(`/course/library/edit/${courseId}`)
    },
    // 章节管理
    handleSection({ courseId, courseName }) {
      this.$router.push(`/course/library/section/${courseId}?courseName=${courseName}`)
    },
    async handleStatusChange(courseId, enable, row) {
      const [, err] = await to(courseStatus({ courseId, enable }))
      if (err) return this.$message.warning(err.msg)
      row.enable = !row.enable
    },
    // 删除
    async handleDelete() {
      if (!this.selectCourse.length) return this.$message.warning('请先选择要删除的课程')
      let courseIds = []
      this.selectCourse.map(item => courseIds.push(item.courseId))
      this.$confirm('确认删除员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [, err] = await to(courseDel({ courseId: courseIds }))
        if (err) return this.$message.warning(err.msg)
        this.$message.success('删除成功')
        this.getCourse()
      })
    },
    // 多选
    handleSelectionChange(val) {
      this.selectCourse = val
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getCourse()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getCourse()
    },
  },
}
</script>
<style scoped lang="scss">
.course-by-self {
  .tableList {
    ::v-deep.table-search-bar {
      .el-form-item .el-date-editor {
        width: 230px !important;
      }
    }
  }
}
</style>
